const Library = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["path", { d: "M16 6L20 20" }],
    ["path", { d: "M12 6V20" }],
    ["path", { d: "M8 8V20" }],
    ["path", { d: "M4 4V20" }]
  ]
];

export default Library;
